export const TID = {
  // Public / nav
  navBrand: "nav-brand",
  navLogin: "nav-login-btn",
  navRegister: "nav-register-btn",
  navLogout: "nav-logout-btn",
  mobileMenuToggle: "mobile-menu-toggle",

  // Home
  heroLookingForWork: "hero-looking-for-work-btn",
  heroLookingToHire: "hero-looking-to-hire-btn",
  homeIndustriesGrid: "home-industries-grid",
  homeFeaturedJobsGrid: "home-featured-jobs-grid",
  homeFaq: "home-faq",
  homeContactSubmit: "home-contact-submit",
  homeContactName: "home-contact-name",
  homeContactEmail: "home-contact-email",
  homeContactMessage: "home-contact-message",

  // Auth
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  registerEmail: "register-email",
  registerPassword: "register-password",
  registerName: "register-name",
  registerRoleCandidate: "register-role-candidate",
  registerRoleEmployer: "register-role-employer",
  registerCompany: "register-company",
  registerSubmit: "register-submit",

  // Dashboards
  agencyDashboard: "agency-dashboard",
  employerDashboard: "employer-dashboard",
  candidateDashboard: "candidate-dashboard",

  // Agency
  agencyKpi: (k) => `agency-kpi-${k}`,
  agencyPipelineBoard: "agency-pipeline-board",
  agencyCandidatesTable: "agency-candidates-table",
  agencyEmployersTable: "agency-employers-table",
  agencyJobsTable: "agency-jobs-table",

  // Employer
  employerJobsTable: "employer-jobs-table",
  employerCandidatesTable: "employer-candidates-table",
  employerCreateJob: "employer-create-job-btn",

  // Candidate
  candidateResumeUpload: "candidate-resume-upload",
  candidateApplyBtn: "candidate-apply-btn",
  candidateSaveBtn: "candidate-save-btn",
  candidateApplicationsTable: "candidate-applications-table",

  // Jobs
  jobSearchInput: "job-search-input",
  jobFilterIndustry: "job-filter-industry",
  jobCard: (id) => `job-card-${id}`,

  // Messages
  messagesThreadList: "messages-thread-list",
  messagesInput: "messages-input",
  messagesSend: "messages-send-btn",
};
